import { createSlice, isPending, SliceSelectors } from "@reduxjs/toolkit";

import { getCountriesThunk } from "./thunks";
import { ICountryState } from "./types";

const initialState = {
  countries: [],
  pending: false,
};

export const countriesSlice = createSlice<
  ICountryState,
  NonNullable<unknown>,
  "optInSlice",
  SliceSelectors<ICountryState>
>({
  name: "optInSlice",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getCountriesThunk.fulfilled, (state, { payload }) => {
      state.countries = payload;
    });
    builder.addMatcher(isPending(getCountriesThunk), state => {
      state.pending = true;
    });
  },
});

export default countriesSlice.reducer;
